/**
 * Permission codes the revenue policy screens declare an interest in
 * (`server/internal/revpolicy/permissions.go`, FIN-FR-034).
 *
 * `revpolicy.manage` and `revpolicy.approve` are a declared segregation-of-duties pair: whoever
 * prepares a policy version must not be the one who puts it in force. On top of the pair, the
 * server allows ONLY the preparer (`createdBy`) to edit, submit or discard a draft; the screens
 * hide those three actions from everybody else, exactly as the server refuses them.
 */

export const REVPOLICY_PERMISSIONS = {
  /** The policy in force, its versions and the departures report. */
  read: 'revpolicy.read',
  /** Draft, edit, submit, supersede and discard policy versions. */
  manage: 'revpolicy.manage',
  /** Decide a `revpolicy.policy` approval task in the inbox. */
  approve: 'revpolicy.approve',
} as const

export type RevpolicyPermission = (typeof REVPOLICY_PERMISSIONS)[keyof typeof REVPOLICY_PERMISSIONS]
